export default __webpack_public_path__ + "3bd6025.png";